import { degreeToRadian, isEmpty, merge } from "@visactor/vutils";

export function transformLegendTitleAttributes(title) {
    var _a, _b;
    const transformedTitle = Object.assign({}, title);
    return isEmpty(title.style) || (transformedTitle.textStyle = transformToGraphic(title.style)), 
    isEmpty(title.textStyle) || merge(transformedTitle.textStyle, transformToGraphic(title.textStyle)), 
    (null === (_a = title.shape) || void 0 === _a ? void 0 : _a.style) && transformToGraphic(transformedTitle.shape.style), 
    (null === (_b = title.background) || void 0 === _b ? void 0 : _b.style) && transformToGraphic(transformedTitle.background.style), 
    transformedTitle;
}

export function transformToGraphic(style) {
    return isEmpty(style) || style.angle && (style.angle = degreeToRadian(style.angle)), 
    style;
}

export function transformComponentStyle(cfg = {}) {
    return isEmpty(cfg.style) || (cfg.style = transformToGraphic(cfg.style)), isEmpty(cfg.state) || Object.keys(cfg.state).forEach((key => {
        isEmpty(cfg.state[key]) || (cfg.state[key] = transformToGraphic(cfg.state[key]));
    })), cfg;
}

export function transformStateStyle(stateStyle) {
    return isEmpty(stateStyle) ? null : (Object.keys(stateStyle).forEach((key => {
        isEmpty(stateStyle[key]) || (stateStyle[key] = transformToGraphic(stateStyle[key]));
    })), stateStyle);
}

export function transformAxisLineStyle(lineCfg) {
    return transformComponentStyle(lineCfg), transformComponentStyle(lineCfg.startSymbol), 
    transformComponentStyle(lineCfg.endSymbol), lineCfg;
}
//# sourceMappingURL=transform.js.map
